import React from 'react';
import clsx from 'clsx';

import Select from 'components/FormFields/Select';

/**
 * A component that renders a dropdown select input.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the select input.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper.
 * @param {string} [props.labelClasses] - Additional CSS classes for the label.
 * @param {string} props.label - The text to display for the label.
 * @param {string} props.name - The name of the input, used for id.
 * @param {Array} props.options - An array of option objects.
 * @param {number} props.options[].id - The unique ID of the option.
 * @param {string} props.options[].optionLabel - The label for the option.
 * @param {boolean} props.options[].selected - Whether the option is selected.
 * @param {function(number): void} props.handleDropdownChange - The function to call when the selection changes.
 * @param {number} props.value - The currently selected option ID.
 */
export const Dropdown = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  label,
  name,
  options,
  handleDropdownChange,
  value,
}) => {
  return (
    <div
      className={clsx(wrapperClasses, 'custom-form-field--dropdown')}
    >
      <label
        className={labelClasses}
        htmlFor={`custom-form-field-${name}`}
      >
        {label}
      </label>
      <Select
        wrapperProps={{
          className: clsx(wrapperClasses, 'custom-form-field--dropdown'),
        }}
        className={inputClasses}
        id={`custom-form-field-${name}`}
        name={label}
        labelProps={{ className: clsx('custom-form-field__label', labelClasses) }}
        responsive={false}
        onChange={(e) => handleDropdownChange(parseInt(e.target.value, 10))}
        value={value}
      >
        {options.map(({ id: optionId, optionLabel, selected }, index) => {
          return (
            <option
              id={`dropdown--${optionId}--${index}`}
              value={optionId}
              className={clsx('button--unstyled', 'option', selected && 'selected')}
            >
              {optionLabel}
            </option>
          );
        })}
      </Select>
    </div>
  );
};
